import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';
import { ContactInfo } from './types';

type GetContatSearchedInfo = { contact: ContactInfo };
export const searchUser = async (field: string, value: string): Promise<AxiosResponse<GetContatSearchedInfo>> =>
  AxiosInstance.get(`omnichannel/contact.search?${field}=${value}`);
